module.exports = __webpack_public_path__ + "img/deng2.86c574cf.png";